module.exports = __webpack_public_path__ + "static/media/SO4.fa86651d.jpg";